import axios from 'axios';

/** Base URL for API (no trailing slash). CRA: REACT_APP_API_URL */
export function getApiOrigin() {
  const base = process.env.REACT_APP_API_URL || '';
  return String(base).replace(/\/+$/, '');
}

/** Absolute URL for an API path when REACT_APP_API_URL is set; otherwise same-origin path. */
export function apiUrl(path) {
  const origin = getApiOrigin();
  const p = path.startsWith('/') ? path : `/${path}`;
  return origin ? `${origin}${p}` : p;
}

const API_URL = getApiOrigin();

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;

